// extracted by mini-css-extract-plugin
var _1 = "AuthAbout-modulehelpText__yJssf AuthHelpText-moduleAuthHelpText__HX0rS";
var _2 = "AuthAbout-modulelink__YlUr2";
var _3 = "AuthAbout-moduletitle__xXgYF AuthTitle-moduleAuthTitle__VKaTa";
var _4 = "AuthAbout-moduleversion__EdHMr";
export { _1 as "helpText", _2 as "link", _3 as "title", _4 as "version" }
